import { PublicSharedApiService } from '../public-shared-api.service';
import { endpoint } from '../shared-api.service';

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getOgpSsoIdentityProvider = async (email: string): Promise<string | null> => {
  const trimmed = email.trim();
  if (trimmed === '') {
    return null;
  }

  return publicSharedApi.get<string>({
    path: `ogp-sign-in-sso/${trimmed}`,
  });
};
